import { render, staticRenderFns } from "./InsuranceForm.vue?vue&type=template&id=2d85a40a"
import script from "./InsuranceForm.vue?vue&type=script&lang=js"
export * from "./InsuranceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports